var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconFolderLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconFolder",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1807.059 1637.706c0 31.172-25.412 56.47-56.47 56.47H169.411c-31.06 0-56.47-25.298-56.47-56.47V225.94h590.907L854.4 451.824H225.882v112.94H1807.06v1072.942ZM990.269 451.824 764.385 113H0v1524.706c0 93.402 76.01 169.412 169.412 169.412h1581.176c93.403 0 169.412-76.01 169.412-169.412V451.824H990.268Z",
      fillRule: "evenodd"
    })));
  }
}
IconFolderLine.glyphName = 'folder';
IconFolderLine.variant = 'Line';
IconFolderLine.displayName = 'IconFolderLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconFolderLine.propTypes = {
  ...SVGIcon.propTypes
};
IconFolderLine.allowedProps = [...SVGIcon.allowedProps];
export default IconFolderLine;
export { IconFolderLine };